export default function AssumedVector() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
			<g stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#a)">
				<path d="M8 14.67A6.67 6.67 0 1 0 8 1.33a6.67 6.67 0 0 0 0 13.34" />
				<path d="M6.06 6a2 2 0 0 1 3.89.67c0 1.33-2 2-2 2M8 11.33z" />
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h16v16H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
